<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-title>{{ title }}</template>
    <div class="d-block text-center">
      {{ content }}
    </div>
    <b-button class="mt-3 btn-primary" block @click="confirm()">
      {{ confirmText ? confirmText : "OK" }}
    </b-button>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: String,
    title: String,
    content: String,
    onConfirm: Function,
    confirmText: String,
  },
  methods: {
    confirm() {
      if (this.onConfirm) {
        this.onConfirm();
      }
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

